/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ConditionOutlineIcon = function ConditionOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M13 3V7H16C17.6569 7 19 8.34315 19 10V11H17V10C17 9.44772 16.5523 9 16 9H8.00003C7.44774 9 7.00003 9.44772 7.00003 10V11H5.00003V10C5.00003 8.34315 6.34317 7 8.00003 7H11V3H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8285 17.0711L14.7071 14.9498L13.2929 16.364L16.8285 19.8995L22.4853 14.2427L21.0711 12.8285L16.8285 17.0711Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65689 18.0711L7.77819 20.1924L9.19241 18.7782L7.0711 16.6569L9.19243 14.5356L7.77822 13.1213L5.65689 15.2427L3.53555 13.1213L2.12134 14.5356L4.24268 16.6569L2.12137 18.7782L3.53558 20.1924L5.65689 18.0711Z"
  }));
};
export default ConditionOutlineIcon;